/* eslint-disable */
import styles from './index.module.scss'
import { Button, FormButton } from '../../components/core/button'
import { GeneralInput } from '../../components/core/input'
import { useState, useRef, useContext, useEffect } from 'react'
import StepLine from '../../components/core/stepLine'
import { Module } from '../../components/core/module'
import { Account, LangArrows, Map, Education, Work } from '../../icons'
import Loading from '../../components/pages/loading'
import translate from '../../utils/translate.json'
import { PageContext } from '../../context/PageContextProvider'
import SelectsAPI from '../../api/selects'

const JournalForm = ({ className }) => {
  const { language } = useContext(PageContext)
  function generateGraduation() {
    var max = new Date().getFullYear() + 10
    var min = max - 75
    var years = []

    for (var i = max; i >= min; i--) {
      years.push(i)
    }
    return years
  }
  const [verify, setVerify] = useState(null)
  const [error, setError] = useState(null)
  const [checked, setChecked] = useState(false)
  const [module, setModule] = useState(false)
  const [choose, setChoose] = useState(translate.choose[language])

  const [data1, setData1] = useState([])
  const [data2, setData2] = useState([])
  const [load, setLoad] = useState(false)

  useEffect(() => {
    (async () => {

    const data1 = await SelectsAPI.getGender()
    const data2 = await SelectsAPI.getMarital()
    await setData1(data1.data)
    await setData2(data2.data)
    await setLoad(true)
  
    })();
  }, [])
  const eduRef = useRef(null)
  const [isVisible4, setIsVisible4] = useState(false)
  const [isVisible6, setIsVisible6] = useState(false)
  const [gender, setGender] = useState(choose)
  const [martial, setMartial] = useState(choose)
  const [graduation1, setGraduation1] = useState(translate.year[language])
  const [edu1, setEdu1] = useState(false)
  const graduations = generateGraduation()
  const steps = [
    {
      title: translate.add_info,
      text: translate.add_address,
    },
    {
      title: translate.mark,
      text: translate.share,
    },
    {
      title: translate.finish,
      text: translate.finish_text,
    },
  ]
  const sendAppeal = () => {
    if (!verify || verify === null) {
      alert(translate.alert_verification[language])
      return
    }
    const fullname = document.querySelector('#journal-fullname')?.value.trim()
    if (fullname === '') {
      alert(translate.alert[language])
      return
    }
    const birth = document.querySelector('#journal-birth')?.value.trim()
    if (birth === '') {
      alert(translate.alert[language])
      return
    }
    const phone = document.querySelector('#journal-phone')?.value.trim() || ''
    if (phone === '') {
      alert(translate.alert[language])
      return
    }
    if (
      !/^\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/.test(
        phone,
      )
    ) {
      alert(translate.alert_phone[language])
      return
    }
    const email = document.querySelector('#journal-email')?.value.trim()
    if (email === '') {
      alert(translate.alert[language])
      return
    }
    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
      alert(translate.alert_email[language])
      return
    }
    if (gender === choose) {
      alert(translate.alert[language])
      return
    }
    const country = document.querySelector('#journal-country')?.value.trim()
    if (country === '') {
      alert(translate.alert[language])
      return
    }
    const city = document.querySelector('#journal-city')?.value.trim()
    if (city === '') {
      alert(translate.alert[language])
      return
    }
    const university = document
      .querySelector('#journal-university')
      ?.value.trim()
    if (university === '') {
      alert(translate.alert[language])
      return
    }
    const faculty = document.querySelector('#journal-faculty')?.value.trim()
    if (faculty === '') {
      alert(translate.alert[language])
      return
    }
    const lang_study = document
      .querySelector('#journal-lang_study')
      ?.value.trim()
    if (lang_study === '') {
      alert(translate.alert[language])
      return
    }
    const education = {
      university,
      faculty,
      language: lang_study,
      graduationYear: graduation1,
    }
    const position = document.querySelector('#journal-position')?.value.trim()
    if (position === '') {
      alert(translate.alert[language])
      return
    }
    const gen_experience = document
      .querySelector('#journal-experience')
      ?.value.trim()
    if (gen_experience === '') {
      alert(translate.alert[language])
      return
    }
    const relevant_experience = document
      .querySelector('#journal-relevant')
      .value.trim()
    if (relevant_experience === '') {
      alert(translate.alert[language])
      return
    }
    const experience = {
      position,
      generalExperience: gen_experience,
      fieldExperience: relevant_experience,
    }
    const note = document.querySelector('#journal-note')?.value.trim()
    const data = {
      fullname,
      birth,
      gender,
      martial_status: martial,
      phone,
      email,
      address: `${country}, ${city}`,
      education,
      experience,
      note,
      options: [],
    }
    sessionStorage.setItem('journal', JSON.stringify(data))
    window.location.href = '/journal-form-step-2'
  }
  return load ? (
    <>
      <section className={`${className} ${styles.container}`}>
        <StepLine active={0} data={steps} />
        <div className={`${styles.content}`}>
          <h2>
            <Account /> {translate.about[language]}
          </h2>
          <div className={styles.about}>
            <GeneralInput
              label={translate.fullname[language]}
              type="text"
              placeholder={translate.enter_fullname[language]}
              id="journal-fullname"
            />
            <GeneralInput
              id="journal-birth"
              label={translate.date[language]}
              type="date"
            />
          </div>
          <div className={styles.email}>
            <GeneralInput
              label={translate.email[language]}
              type="text"
              id="journal-email"
              placeholder={translate.email_ph[language]}
              onInput={(e) => {
                setError(
                  !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(
                    e.target.value,
                  ),
                )
              }}
              style={{
                border: error ? '1px solid red' : '1px solid #C5CEE0',
                pointerEvents: verify ? 'none' : 'auto',
                opacity: verify ? 0.5 : 1,
              }}
            />
            <Button
              click={() => {
                if (!error && error !== null) {
                  setModule(true)
                }
              }}
              style={
                verify && {
                  backgroundColor: '#C5CEE0',
                  border: '1px solid #C5CEE0',
                  color: '#fff',
                  pointerEvents: 'none',
                }
              }
              to={'#'}
              version2={true}
            >
              {verify
                ? translate.verified[language]
                : translate.verify[language]}
            </Button>
          </div>
          <div className={styles.gender}>
            <div
              className={styles.select}
              onBlur={() =>
                setTimeout(function () {
                  setIsVisible4(false)
                }, 250)
              }
            >
              <p>{translate.gender[language]}</p>
              <span tabIndex="1" onClick={() => setIsVisible4(true)}>
                {gender} <LangArrows />
              </span>
              <ul
                style={isVisible4 ? { display: 'block' } : { display: 'none' }}
              >
                {data1.map((e) => (
                  <li
                    onClick={() => {
                      setGender(e[language])
                    }}
                  >
                    {e[language]}
                  </li>
                ))}
              </ul>
            </div>
            <div
              className={styles.select}
              onBlur={() =>
                setTimeout(function () {
                  setIsVisible6(false)
                }, 250)
              }
            >
              <p>{translate.martial[language]}</p>
              <span tabIndex="1" onClick={() => setIsVisible6(true)}>
                {martial} <LangArrows />
              </span>
              <ul
                style={isVisible6 ? { display: 'block' } : { display: 'none' }}
              >
                {data2.map((e) => (
                  <li
                    onClick={() => {
                      setMartial(e[language])
                    }}
                  >
                    {e[language]}
                  </li>
                ))}
              </ul>
            </div>
            <GeneralInput
              label={translate.phone[language]}
              type="tel"
              placeholder="+994 XX XXX XX XX"
              id="journal-phone"
            />
          </div>
          <h2>
            <Map /> {translate.current_address[language]}
          </h2>
          <div className={styles.address}>
            <GeneralInput
              label={translate.country[language]}
              type="text"
              placeholder={translate.enter_info[language]}
              id="journal-country"
            />
            <GeneralInput
              label={translate.city[language]}
              type="text"
              placeholder={translate.enter_info[language]}
              id="journal-city"
            />
          </div>
          <h2>
            <Education />
            {translate.education[language]}
            <span>({translate.edu_info[language]})</span>
          </h2>
          <div ref={eduRef} className={`education ${styles.education}`}>
            <div className={styles.edu}>
              <div>
                <GeneralInput
                  label={translate.university[language]}
                  type="text"
                  placeholder={translate.enter_info[language]}
                  id="journal-university"
                />
                <GeneralInput
                  label={translate.faculty[language]}
                  type="text"
                  placeholder={translate.enter_info[language]}
                  id="journal-faculty"
                />
              </div>
              <div>
                <GeneralInput
                  label={translate.lang_study[language]}
                  type="text"
                  placeholder={translate.enter_info[language]}
                  id="journal-lang_study"
                />
                <div
                  className={styles.select}
                  onBlur={() =>
                    setTimeout(function () {
                      setEdu1(false)
                    }, 250)
                  }
                >
                  <p>{translate.gra_year[language]}</p>
                  <span tabIndex="1" onClick={() => setEdu1(true)}>
                    {graduation1} <LangArrows />
                  </span>
                  <ul style={edu1 ? { display: 'block' } : { display: 'none' }}>
                    {graduations.map((e) => (
                      <li
                        onClick={() => {
                          setGraduation1(e)
                        }}
                      >
                        {e}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <h2>
            <Work /> {translate.experience[language]}
            <span>({translate.work_info[language]})</span>
          </h2>
          <div className={styles.experience}>
            <GeneralInput
              label={translate.current_position[language]}
              type="text"
              placeholder={translate.enter_position[language]}
              id="journal-position"
            />
            <GeneralInput
              label={translate.general_experience[language]}
              type="text"
              placeholder={translate.eg1[language]}
              id="journal-experience"
            />
            <GeneralInput
              label={translate.relevant_field[language]}
              type="text"
              placeholder={translate.eg2[language]}
              id="journal-relevant"
            />
          </div>
          <div className={styles.textarea}>
            <p>{translate.note[language]}</p>
            <span>{translate.not_required[language]}</span>
            <textarea
              id="journal-note"
              placeholder={translate.write_note[language]}
            ></textarea>
          </div>
          <FormButton onClick={() => sendAppeal()}>
            {translate.save_next[language]}
          </FormButton>
        </div>
      </section>
      {module && (
        <div className={styles.module}>
          <Module
            email={document.getElementById('journal-email').value.trim()}
            setModule={setModule}
            setVerify={setVerify}
            click={() => {
              setModule(false)
            }}
            verify={verify}
          />
        </div>
      )}
    </>
  ) : (
    <Loading />
  )
}

export default JournalForm
